import React, { useState, useEffect } from "react";
import "../css/Logout.css";
import CloseIcon from "@mui/icons-material/Close";
import { openDB } from "idb";
import { clearFBDeviceId } from "../firebase/handle_loggedIn_device";

const Logout = ({ onClose }) => {
  const [logoutHover, setLogoutHover] = useState(false);
  const [isClearLoding, setIsClearLoding] = useState(false);
  const [message, setMessage] = useState("");
  const [messageTwo, setMessageTwo] = useState("");
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);

  const SimpleLogout = () => {
    setLoading(true);
    localStorage.setItem("Simple_logout", "0");
    sessionStorage.removeItem('token')
    window.location.pathname = "/login";
  };

  const ClearLogout = () => {

    setIsClearLoding(true);
    sessionStorage.clear();
    localStorage.clear();

    var DBDeleteRequest = window.indexedDB.deleteDatabase("FoodDo");

    DBDeleteRequest.onerror = function (event) {
      console.log("Error deleting database.");
      console.log("Error : ", event.result);
      window.location.reload();
    };

    DBDeleteRequest.onsuccess = function (event) {

      console.log("Database deleted successfully");
      console.log(event.result); // should be undefined

      setMessage("Bye!!")
      window.location.pathname = "/login";
    };
  };

  useEffect(() => {
    const getData = async () => {
      let db = await openDB(
        "FoodDo",
        +localStorage.getItem("IDBVersion") || 1
      );
      let tx = db.transaction("unsynced_files", "readwrite");
      let store = tx.objectStore("unsynced_files");
      let unsynced = await store.getAll();
      if (unsynced?.length) {
        console.log("unsynced data", unsynced)
        setDisabled(true);
        setMessage(
          'Unable to Refresh Local Data. Some unsynced data in "unsynced_files" Table.'
        );

      };

    };
    getData();
  }, [confirmPopup]);

  useEffect(() => {
    const getData = async () => {
      let db = await openDB(
        "FoodDo",
        +localStorage.getItem("IDBVersion") || 1
      );
      let tx = db.transaction("running_orders", "readwrite");
      let store = tx.objectStore("running_orders");
      let runningOrders = await store.getAll();


      if (
        runningOrders.filter((item) => item.IsSynched === 1)
          .length
      ) {
        console.log("unsynced_running", runningOrders.filter((item) => item.IsSynched === 1))
        setDisabled(true);
        setMessageTwo('Some unsynced data in "running_orders" Table.');
      }

    };
    getData();
  }, [confirmPopup]);

  return (
    <>
      <div className="logoutPopup">
        <div className="logout_content">
          <CloseIcon className="button_Close" onClick={() => onClose()} />
          <h1>Logout</h1>
          <div className="logout_button">
            <div className="button_container">
              {!loading ? (
                <button className="simple_Logout_button" onClick={() => clearFBDeviceId(SimpleLogout)}>
                  Logout
                </button>
              ) : (
                <button className="clear_Logout_button" id="loading-screen">
                  <svg viewBox="0 0 100 100">
                    <path
                      d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                      fill="#ffffff"
                      stroke="none"
                    >
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        dur="1s"
                        repeatCount="indefinite"
                        keyTimes="0;1"
                        values="0 50 51;360 50 51"
                      ></animateTransform>
                    </path>
                  </svg>
                </button>
              )}
              <h5>Use On Trusted Device</h5>
            </div>
            <div className="button_container">
              {!isClearLoding ? (
                <button
                  className="clear_Logout_button"
                  onMouseOver={() => setLogoutHover(true)}
                  onMouseLeave={() => setLogoutHover(false)}
                  onClick={() => {
                    if (!disabled) {
                      clearFBDeviceId(ClearLogout)
                    } else {
                      setConfirmPopup(true)
                    }
                  }}
                >
                  Logout & Clear Data
                </button>
              ) : (
                <button className="clear_Logout_button" id="loading-screen">
                  <svg viewBox="0 0 100 100">
                    <path
                      d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                      fill="#ffffff"
                      stroke="none"
                    >
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        dur="1s"
                        repeatCount="indefinite"
                        keyTimes="0;1"
                        values="0 50 51;360 50 51"
                      ></animateTransform>
                    </path>
                  </svg>
                </button>
              )}
              <h5>Use On Guest Device</h5>
              {logoutHover && (
                <div className="talkbubble">
                  <div id="talkbubble">Internet required for Next Login</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {confirmPopup ? (
        <ConfirmMessagePopup
          ClearLogout={ClearLogout}
          isClearLoding={isClearLoding}
          setConfirmPopup={setConfirmPopup}
          message={message}
          messageTwo={messageTwo}
          clearFBDeviceId={clearFBDeviceId}
        />
      ) : (
        ""
      )}
    </>
  );
};
const ConfirmMessagePopup = ({
  ClearLogout,
  isClearLoding,
  setConfirmPopup,
  message,
  messageTwo,
  clearFBDeviceId
}) => {
  return (
    <div className="logoutPopup" style={{ zIndex: "9999" }}>
      <div className="logout_content">
        <h1 style={{ color: "red" }}>Warning!!!</h1>
        {message ? <div>{message}</div> : ""}
        {messageTwo ? <div>{messageTwo}</div> : ""}

        <div className="logout_button">
          <div className="button_container">
            {!isClearLoding ? (
              <button
                style={{ background: "red" }}
                className="clear_Logout_button"
                onClick={() => {
                  clearFBDeviceId(ClearLogout);
                }}
              >
                Confirm
              </button>
            ) : (
              <button className="clear_Logout_button" id="loading-screen">
                <svg viewBox="0 0 100 100">
                  <path
                    d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                    fill="#ffffff"
                    stroke="none"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      dur="1s"
                      repeatCount="indefinite"
                      keyTimes="0;1"
                      values="0 50 51;360 50 51"
                    ></animateTransform>
                  </path>
                </svg>
              </button>
            )}
          </div>
          <div className="button_container">
            <button
              className="simple_Logout_button"
              onClick={() => setConfirmPopup(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Logout;
